import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import App from './app';
import ChooseOrganization from './modules/chooseorg/chooseorg';
import ErrorFragment from './modules/ui/errors/error';

const clientRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: 'user/chooseorg',
        element: <ChooseOrganization />,
      },
      {
        path: 'user/error/:code?',
        element: <ErrorFragment />,
      },
    ],
  },
];

function RouterComponent() {
  return (
    <Router>
      <Routes>
        {clientRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {route.children && route.children.map((child, childIndex) => (
              <Route key={childIndex} path={child.path} element={child.element} />
            ))}
          </Route>
        ))}
      </Routes>
    </Router>
  );
}

export default RouterComponent;
export { clientRoutes };
